<lib-page-layout>
  <lib-title-navbar pageHeader [showDots]="true" (onDotsClicked)="manageTeam()" title="Twoja grupka"></lib-title-navbar>

  <div class="or-px-16-px or-pt-16-px">
    @if (teamDetails(); as teamDetails) {
      <lib-team-card [teamDetails]="teamDetails" [showInfoLabel]="true" [showShareIcon]="false"></lib-team-card>

      @if (teamDetails.memberRole === 'Member') {
        <div class="or-d-flex or-align-items-center or-mt-16-px">
          <lib-or-avatar
            [avatarUrl]="teamDetails.host.thumbnail"
            [initials]="teamDetails.host.displayName"
            [redirectToUserProfile]="teamDetails.host.hostId"
            [avatarSize]="'sm'"></lib-or-avatar>
          <div class="or-d-flex or-justify-content-between or-w-100-pc">
            <div class="or-max-w-60-pc" [redirectToUserProfile]="teamDetails.host.hostId">
              <div class="or-head-xs or-color-secondary-2">Organizator</div>
              <div class="or-head-sm">{{ teamDetails.host.displayName }}</div>
            </div>

            <div class="or-d-flex or-align-items-center">
              <or-icon
                name="contact"
                size="s"
                boxed
                class="or-color-white or-bg-main-1 or-mr-4-px"
                (click)="sendMessage(teamDetails.host.hostId, teamDetails.host.displayName)" />

              <button
                [copyToClipboard]="teamDetails.host.phone"
                class="button-primary-style or-align-items-center or-d-flex or-head-md or-justify-content-between or-px-8-px or-h-32-px or-cursor-pointer"
                [class.disabled-button]="!teamDetails.host.phone">
                <or-icon name="phone" size="xs" class="or-mr-4-px or-color-white" />
                <span class="or-color-white or-head-xs text-no-wrap" [class.disabled-button]="!teamDetails.host.phone"
                  >Skopiuj numer
                </span>
              </button>
            </div>
          </div>
        </div>
      }
      @if (teamDetails.members.length) {
        <div class="or-head-xs or-color-secondary-2 or-mt-24-px or-mb-12-px">Lista graczy w grupce</div>
      }
      @for (member of teamDetails.members; track member.userId; let i = $index) {
        <div class="or-d-flex or-justify-content-between">
          <div class="or-d-flex or-align-items-center" [redirectToUserProfile]="member.userId">
            <lib-or-avatar
              [avatarUrl]="member.thumbnail"
              [initials]="member.displayName"
              [avatarSize]="'sm'"></lib-or-avatar>

            <div class="or-head-sm or-truncate-at-line-1 or-mr-32-px or-d-flex or-align-items-center">
              {{ i + 1 }}. {{ member.displayName }}
              @if (member.memberRole !== 'Member') {
                <or-icon name="organizer" size="m" class="or-ml-8-px" />
              }
              @if (member.isAutoApproved && member.memberRole === 'Member' && teamDetails.memberRole === 'Host') {
                <or-icon name="star" size="xs" circle class="or-ml-4-px or-color-yellow" />
              }
            </div>
          </div>
          @if (member.userId !== userId()) {
            <div class="or-d-flex or-justify-content-end or-align-items-center">
              <or-icon
                name="contact"
                size="xs"
                boxed
                class="or-color-white or-bg-main-1"
                (click)="sendMessage(member.userId, member.displayName)" />

              @if (teamDetails.memberRole !== 'Member') {
                <or-icon
                  (click)="managePlayer(member, teamDetails.teamId)"
                  name="dots-vertical"
                  size="m"
                  class="or-ml-4-px" />
              }
            </div>
          }
        </div>
        <div class="or-d-flex or-justify-content-center or-my-4-px">
          <div class="custom-divider-team-details or-my-4-px"></div>
        </div>
      }
      @if (teamDetails.members.length < 2) {
        <div
          (click)="inviteViaLink()"
          class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
          <or-icon name="copy-link" size="s" boxed class="or-mr-8-px" />

          <div>
            <div class="or-text-md">Zaproś za pomocą linku</div>
            <div class="or-text-sm or-color-secondary-2">Osoba z linkiem zostanie dodana do grupki</div>
          </div>
        </div>

        <div
          (click)="addMember()"
          class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
          <or-icon name="plus" size="s" boxed class="or-mr-8-px" />

          <div>
            <div class="or-text-md">Dodaj graczy do grupki</div>
            <div class="or-text-sm or-color-secondary-2">Dodaj graczy z poprzednich gierek</div>
          </div>
        </div>
      }
    }
  </div>

  <lib-bottom-navbar pageFooter></lib-bottom-navbar>
</lib-page-layout>
